<template>
  <div class="map">
    <div ref="mapPanelTop" class="absolute mapDetailTop"></div>
    <div v-if="from.route">
      <div
        v-show="showMapPanel || showSearchPanel"
        class="z-10 w-full"
        :class="showMapPanel ? 'absolute' : 'sticky'">
        <search-form
          @search="onSearch"
          @incrementSearch="onIncrementSearch"
          @closeSearchPanel="onCloseSearchPanel"
          @openFilterPanel="onOpenFilterPanel"
          @openGenreList="onOpenGenreList"
          @clearForm="clearFrom"
          :onSearch="showSearchPanel"
        />
      </div>
      <div v-show="!showSearchPanel && !showGenreList && !showFilterPanel" class="fixed z-10 mt-16">
        <div>
          <a @click="closeMap()" class="flex border border-link rounded text-link ml-2 mr-3 px-2 py-1 bg-white">
            <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
            <span class="flex justify-center items-center text-sm whitespace-nowrap">{{ closeMapLabel() }}</span>
          </a>
        </div>
        <div class="mt-2">
          <a @click="fitBoundsPlan()" class="flex border border-link rounded text-link ml-2 mr-3 px-2 py-1 bg-white">
            <span class="flex justify-center items-center text-sm whitespace-nowrap">行程全体をMAP上で確認</span>
          </a>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-show="!showFilterPanel" class="pt-4 right-2 absolute z-10 text-right">
        <div class="flex">
          <a @click="onOpenFilterPanel" class="p-2 bg-white border border-pale_green rounded-lg shadow-sm ml-2">
            <svg
              class="m-1 h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1000 1000">
              <path d="M10 780h595v70H10v-70zM815 780h175v70H815v-70zM780 918.9c0 39.3-31.3 71.1-70 71.1s-70-31.8-70-71.1V711.1c0-39.3 31.3-71.1 70-71.1s70 31.8 70 71.1v207.8zM10 465h175v70H10v-70zM395 465h595v70H395v-70zM360 603.9c0 39.3-31.3 71.1-70 71.1s-70-31.8-70-71.1V396.1c0-39.3 31.3-71.1 70-71.1s70 31.8 70 71.1v207.8zM10 150h595v70H10v-70zM815 150h175v70H815v-70zM780 288.9c0 39.3-31.3 71.1-70 71.1s-70-31.8-70-71.1V81.1c0-39.3 31.3-71.1 70-71.1s70 31.8 70 71.1v207.8z"/>
            </svg>
          </a>
        </div>
      </div>
      <div v-show="!showFilterPanel" class="absolute z-20 mt-4">
        <a @click="closeMap()" class="flex border border-link rounded text-link ml-2 mr-3 px-2 py-1 bg-white">
          <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <span class="flex justify-center items-center text-sm whitespace-nowrap">{{ closeMapLabel() }}</span>
        </a>
      </div>
      <div v-show="!showFilterPanel" class="absolute z-20 mt-12 pt-1">
        <a @click="fitBoundsPlan()" class="flex border border-link rounded text-link ml-2 mr-3 px-2 py-1 bg-white">
          <span class="flex justify-center items-center text-sm whitespace-nowrap">行程全体をMAP上で確認</span>
        </a>
      </div>
    </div>
    <div v-show="showMapPanel" class="h-full w-full">
      <map-panel
        ref="mapPanel"
        @search="onSearch"
        @closeSearchPanel="onCloseSearchPanel"
        @openFilterPanel="onOpenFilterPanel"
        @closeMap="closeMap"
        :zoomLevel="zoomLevel"
      />
    </div>
    <div v-if="showSearchPanel" class="absolute h-full w-full pb-4">
      <search-panel
        @selectGenre="onSelectGenre"
        @closeSearchPanel="onCloseSearchPanel"
        @clearForm="clearFrom"
        :genre="genre"
        :searchWord="searchWord"
        searchType="Departure"
      />
    </div>
    <div v-if="showGenreList" class="h-full w-full pb-4">
      <genre-list
        @close="onCloseGenreList"
        @selectGenre="onSelectGenre"
      />
    </div>
    <div v-show="showFilterPanel" class="h-full w-full pb-4">
      <filter-panel
        @close="onCloseFilterPanel"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import SearchForm from '../organisms/Map/SearchForm'
import SearchPanel from '../organisms/Map/SearchPanel'
import GenreList from '../organisms/Map/GenreList'
import FilterPanel from '../organisms/Map/FilterPanel'
import MapPanel from '../organisms/Map/MapPanel'

export default {
  created () {
    this.$store.dispatch('drawer/close')
    this.$store.dispatch('busLocation/close')
    this.$store.dispatch('genres/fetchAll')
      .then(() => {
        this.$store.dispatch('places/fetchAll')    
          .then(() => {
            this.$refs.mapPanel.mapInitialized()
            // お気に入り施設の取得
            if (this.token) {
              this.$store.dispatch('favorites/fetchAll').then(() => {
                const favoriteGenre = this.$store.getters['genres/getFavoriteGenre']
                if (favoriteGenre !== undefined) {
                  const favorites = this.$store.getters['favorites/getFavorites']
                  for (var i = 0; i < favorites.length; i++) {
                    this.$store.dispatch('places/updateFavoritePlace', { id: favorites[i], favoriteId: favoriteGenre.id, favorited: true, favoriteIcon: favoriteGenre.filterIcon})
                  }
                  const genres = this.$store.getters['genres/getAll']
                  this.$store.dispatch('user/updateFilter', genres)
                }
              })
            }
          })
      })
      this.$store.dispatch('drawer/showButton')
  },
  components: {
    SearchForm,
    SearchPanel,
    GenreList,
    FilterPanel,
    MapPanel,
  },
  data () {
    return {
      showMapPanel: true,
      showSearchPanel: false,
      showGenreList: false,
      showFilterPanel: false,
      showBusLocation: false,
      genre: {},
      searchWord: '',
      zoomLevel: 15,
      showFilterMenu: true,
      isOpenSearchPanel: true
    }
  },
  mounted () {
    // Safariだとアドレスバーの有無で位置がずれるため、表示後に調整する
    this.$refs['mapPanelTop'].scrollIntoView({ behavior: 'instant'})
  },
  methods: {
    onSearch: function () {
      this.showSearchPanel = true
      this.showPlaceList = false
      this.showMapPanel = false
      this.showFilterMenu = false
    },
    onCloseSearchPanel: function () {
      this.showSearchPanel = false
      this.showMapPanel = true
      this.genre = {}
      this.showFilterMenu = true
    },
    onOpenGenreList: function () {
      this.showMapPanel = false
      this.showSearchPanel = false
      this.showGenreList = true
    },
    onCloseGenreList: function () {
      this.showGenreList = false
      this.showSearchPanel = false
      this.showMapPanel = true
    },
    onOpenFilterPanel: function () {
      this.showFilterPanel = true
      this.showSearchPanel = false
      this.showMapPanel = false
    },
    onCloseFilterPanel: function () {
      this.showMapPanel = true
      this.showFilterPanel = false
    },
    onSelectGenre: function (genre) {
      this.genre = genre
      this.showGenreList = false
      this.showSearchPanel = true
      this.$refs['mapPanelTop'].scrollIntoView({ behavior: 'smooth'})
    },
    onIncrementSearch: function (word) {
      this.searchWord = word
    },
    handleError: function (errorCode) {
      switch (errorCode) {
        case 1: //PERMISSION_DENIED
          alert(this.$t('map_permission_denied_error_message'))
          break
        case 2: //POSITION_UNAVAILABLE
          alert(this.$t('map_position_unavailable_error_message'))
          break
        case 3: //TIMEOUT
          alert(this.$t('map_timeout_error_message'))
          break
        default:
          alert(this.$t('map_default_error_message'))
          break
      }
    },
    getPlaces: function () {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('places/fetchAll')
        .then(() => {
          const genres = this.$store.getters['genres/getAll']
          this.$store.dispatch('user/updateFilter', genres)
          if (this.token) {
            const favoriteGenre = this.$store.getters['genres/getFavoriteGenre']
            if (favoriteGenre !== undefined) {
              const favorites = this.$store.getters['favorites/getFavorites']
              for (var i = 0; i < favorites.length; i++) {
                this.$store.dispatch('places/updateFavoritePlace', { id: favorites[i], favoriteId: favoriteGenre.id, favorited: true, favoriteIcon: favoriteGenre.filterIcon})
              }
              this.$store.dispatch('user/updateFilter', genres)
            }
          }
          this.$store.dispatch('loading/endLoading')
        })
    },
    openSearchPanel: function () {
      this.isOpenSearchPanel = true
      this.$store.dispatch('busLocation/close')
    },
    initMap: function () {
      this.map.addListener("drag", () => {
        this.isOpenSearchPanel = false
      })
    },
    fitBoundsPlan: function () {
      this.$refs.mapPanel.fitBoundsPlan()
    },
    closeMapLabel: function () {
      const path = this.$route.path
      if (path.indexOf('courses') !== -1) {
        return 'モデルコースに戻る'
      } else {
        return '旅行プラン作成に戻る'
      }
    },
    closeMap: function () {
      this.$store.dispatch('drawer/close')
      this.$emit('closeMap')
    },
    clearFrom: function () {
      this.$store.dispatch('map/clearSearchFrom')
      this.searchWord=''
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter',
      selectedPlace: 'drawer/getSelectedPlace',
      showPlaceFull: 'drawer/getShowPlaceFull',
      token: 'user/getToken',
      map: 'googleMap/getMap',
      from: 'map/getFrom'
    })
  },
  watch: {
    selectedPlace: function (val) {
      if (!_.isEmpty(val)) {
        this.showSearchPanel = false
        this.showMapPanel = true
        this.showBusLocation = false
        this.showFilterMenu = true
        this.isOpenSearchPanel = false
      }
    },
    showPlaceFull: function (val) {
      if (val && this.isOpenSearchPanel) {
        this.isOpenSearchPanel = false
      }
    },
    selectedBusStops: function (val) {
      if (!_.isEmpty(val)) {
        this.showMapPanel = true
        this.isOpenSearchPanel = false
      }
    },
    busLocationIsOpen: function (val) {
      this.showBusLocation = val
    },
    map: function () {
      this.initMap()
    },
    center: function (val) {
      if (!_.isEmpty(this.map)) {
        this.map.panTo(val)
      }
    }
  }
}
</script>
<style>
.mapDetailTop {
  top: -3rem;
}
</style>
